import { Component, type ErrorInfo, type ReactNode } from "react";

import {
  activateRacingSafeMode,
  reportClientIncident,
} from "@/app/nativeRecovery";
import { Button, Panel } from "@/components/ui";

type State = { error: Error | null };

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Destination render failure", error, info.componentStack);
    reportClientIncident("react_error_boundary");
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="fatal-error">
        <Panel>
          <h1>The destination hit an unexpected error</h1>
          <p>
            Race and ticket records are safe. Retry with the lightweight player.
          </p>
          <Button
            onClick={() => {
              activateRacingSafeMode();
              window.location.reload();
            }}
          >
            Retry safely
          </Button>
        </Panel>
      </main>
    );
  }
}
